import React, {useEffect} from 'react'
import {createPortal} from 'react-dom'
import Transition from 'react-transition-group/Transition'
import styles from './styles.css'

// Program modals it's more easy with react portals
export default function Modal({isOpen, children}) {
  const modalRoot = document.getElementById('modal')

  const el = document.createElement('div')

  useEffect(() => {
    modalRoot.appendChild(el)
    return () => {
      modalRoot.removeChild(el)
    }
  }, [modalRoot, el])

  return (
    isOpen &&
    createPortal(
      <Transition in={isOpen} timeout={500}>
        <div className={`${styles.container} ${isOpen && styles.open}`}>
          <div className={styles.dialog}>{children}</div>
        </div>
      </Transition>,
      el
    )
  )
}
